module.exports = __webpack_public_path__ + "static/other/cake_decorating.cf5ab99b.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/cake_decorating.json
// module id = 2627
// module chunks = 0